import React, { useContext } from 'react';
import Box from 'js/components/box/box';
import Text from 'js/components/text/text';
import EntityItem from './entity-item';
import entities from '../../../enums/matched-videos-entities.enum';
import styles from '../matched-items-section.module.scss';
import ContextDetailContext from '../../../contexts/context-detail.context';

const CTVVideoCard = ({ image, url, channel, children }) => (
    <div className={styles['ctv-card']}>
        <img src={image} alt="" />
        <img
            style={{
                maxHeight: '40px',
                width: 'auto',
                position: 'absolute',
                margin: 16,
                right: 0,
                top: 0,
                borderRadius: 0,
            }}
            src={channel}
            alt=""
        />
        <a href={url} target="_blank" rel="noopener noreferrer">
            {' '}
        </a>
        <div className={styles['ctv-detail']}>{children}</div>
    </div>
);

export default function MatchedVideoItem({
    matchedVideo: {
        url,
        title,
        thumbnail,
        logos: logoIds,
        topics: topicIds,
        channel_thumbnail: channel,
    },
}) {
    const {
        context: {
            current: { rules },
            setRules,
        },
        topics: { groups: topicGroups, list: topicList },
        logoGroups,
        matchedVideos: { setNeedsReload: setMatchedVideosNeedsReload },
        page: { isReadOnly },
    } = useContext(ContextDetailContext);

    const topics = topicList.filter(
        (topic) => topicIds.includes(topic.id) && !topic.is_brand_safety,
    );

    const bsTopics = topicList.filter(
        (topic) => topicIds.includes(topic.id) && topic.is_brand_safety,
    );

    const logos = logoGroups
        .map((group) => group.logos)
        .flat()
        .filter((brand) => logoIds.includes(brand.id));

    const matchedItemListingStyle = styles['matched-item-listing'];

    return (
        <CTVVideoCard url={url} image={thumbnail} channel={channel}>
            <Box margin="base">
                <Box margin={[0, 0, 'small']}>
                    <Text
                        weight="bolder"
                        size="larger"
                        color={['gray', 'white']}
                    >
                        {title || url.split('?')[0].split('#')[0]}{' '}
                    </Text>
                </Box>
                {topics.length > 0 && (
                    <>
                        <Box margin={['small', 0, 'small']}>
                            <Text weight="bolder" color={['gray', 'white']}>
                                Topics
                            </Text>
                        </Box>

                        <div className={matchedItemListingStyle}>
                            {topics.map((topic) => (
                                <EntityItem
                                    key={topic.id}
                                    entityType={entities.TOPICS}
                                    entity={topic}
                                    entityGroups={topicGroups}
                                    isReadOnly={isReadOnly}
                                    rules={rules}
                                    onChangeRules={(newRules) => {
                                        setRules(newRules);
                                        setMatchedVideosNeedsReload(true);
                                    }}
                                />
                            ))}
                        </div>
                    </>
                )}

                {bsTopics.length > 0 && (
                    <>
                        <Box margin={['small', 0, 'small']}>
                            <Text weight="bolder" color={['gray', 'white']}>
                                Brand Safety Topics
                            </Text>
                        </Box>

                        <div className={matchedItemListingStyle}>
                            {bsTopics.map((topic) => (
                                <EntityItem
                                    key={topic.id}
                                    entityType={entities.TOPICS}
                                    entity={topic}
                                    entityGroups={topicGroups}
                                    isReadOnly={isReadOnly}
                                    rules={rules}
                                    onChangeRules={(newRules) => {
                                        setRules(newRules);
                                        setMatchedVideosNeedsReload(true);
                                    }}
                                />
                            ))}
                        </div>
                    </>
                )}

                {logos.length > 0 && (
                    <>
                        <Box margin={['small', 0, 'small']}>
                            <Text weight="bolder" color={['gray', 'white']}>
                                Brands
                            </Text>
                        </Box>

                        <div className={matchedItemListingStyle}>
                            {logos.map((logo) => (
                                <EntityItem
                                    key={logo.id}
                                    entityType={entities.LOGOS}
                                    entity={logo}
                                    entityGroups={logoGroups}
                                    isReadOnly={isReadOnly}
                                    rules={rules}
                                    onChangeRules={(newRules) => {
                                        setRules(newRules);
                                        setMatchedVideosNeedsReload(true);
                                    }}
                                />
                            ))}
                        </div>
                    </>
                )}
            </Box>
        </CTVVideoCard>
    );
}
